export const PLAID_LINK_STABLE_URL = "https://cdn.plaid.com/link/v2/stable/link-initialize.js";

import { CommonPlaidLinkOptions, PlaidHandler, PlaidHandlerSubmissionData, PlaidLinkOptions } from "./types";

export interface PlaidFactory {
  // biome-ignore lint/complexity/noBannedTypes: i just copied this
  open: (() => void) | Function;
  // biome-ignore lint/complexity/noBannedTypes: i just copied this
  submit: ((data: PlaidHandlerSubmissionData) => void) | Function;
  // biome-ignore lint/complexity/noBannedTypes: i just copied this
  exit: ((exitOptions: any, callback: () => void) => void) | Function;
  // biome-ignore lint/complexity/noBannedTypes: i just copied this
  destroy: (() => void) | Function;
}

interface FactoryInternalState {
  plaid: PlaidHandler | null;
  open: boolean;
  // biome-ignore lint/complexity/noBannedTypes: i just copied this
  onExitCallback: (() => void) | null | Function;
}

const renameKeyInObject = (o: { [index: string]: any }, oldKey: string, newKey: string): object => {
  const newObject = {};
  delete Object.assign(newObject, o, { [newKey]: o[oldKey] })[oldKey];
  return newObject;
};

/**
 * Wrap link handler creation and instance to clean up iframe via destroy() method
 */
// biome-ignore lint/complexity/noBannedTypes: i just copied this
const createPlaidHandler = <T extends CommonPlaidLinkOptions<{}>>(
  config: T,
  creator: (config: T) => PlaidHandler
) => {
  const state: FactoryInternalState = {
    plaid: null,
    open: false,
    onExitCallback: null,
  };

  // If Plaid is not available, throw an Error
  if (typeof window === "undefined" || !window.Plaid) {
    throw new Error("Plaid not loaded");
  }

  state.plaid = creator({
    ...config,
    onExit: (error, metadata) => {
      state.open = false;
      // @ts-ignore
      config.onExit?.(error, metadata);
      // @ts-ignore
      state.onExitCallback?.();
    },
  });

  const open = () => {
    if (!state.plaid) {
      return;
    }
    state.open = true;
    state.onExitCallback = null;
    state.plaid.open();
  };

  const submit = (data: PlaidHandlerSubmissionData) => {
    if (!state.plaid) {
      return;
    }
    state.plaid.submit(data);
  };

  // biome-ignore lint/complexity/noBannedTypes: i just copied this
  const exit = (exitOptions: any, callback: (() => void) | Function) => {
    if (!state.open || !state.plaid) {
      callback?.();
      return;
    }
    state.onExitCallback = callback;
    state.plaid.exit(exitOptions);
    if (exitOptions?.force) {
      state.open = false;
    }
  };

  const destroy = () => {
    if (!state.plaid) {
      return;
    }

    state.plaid.destroy();
    state.plaid = null;
  };

  return {
    open,
    submit,
    exit,
    destroy,
  };
};

export const createPlaid = (
  options: PlaidLinkOptions,
  creator: (options: PlaidLinkOptions) => PlaidHandler
) => {
  const config = renameKeyInObject(options, "publicKey", "key") as PlaidLinkOptions;

  return createPlaidHandler(config, creator);
};
